import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  FormControl,
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useGetTableData } from "hooks/useGetTableData";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const SitesPopover = ({
  popoverWidth,
  setSelectedOption,
  options,
  handleClose,
}) => {
  const { t } = useTranslation();

  const [searchInput, setSearchInput] = useState("");
  const handleSearchInput = (e) => setSearchInput(e.target.value);
  const { setQueryParams } = useGetTableData();

  return (
    <Paper sx={{ width: popoverWidth, pl: 1, pt: 1 }}>
      <FormControl fullWidth>
        <TextField
          value={searchInput}
          onChange={handleSearchInput}
          label="Search List"
          InputLabelProps={{ shrink: true }}
          variant="standard"
          id="site-search"
          aria-describedby="search site input"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            sx: {
              "&.MuiInputBase-root": {
                backgroundColor: "white",
                borderColor: "white",
                mr: 1,
              },
            },
          }}
        />
      </FormControl>
      <List
        sx={{
          paddingBottom: 0,
          maxHeight: "250px",
          overflowY: "auto",
        }}
      >
        {[
          { siteName: "projectsSitesDropdown.noSelectionLabel", siteId: "" },
          ...options,
        ]
          .filter((option) => {
            const inputArray = searchInput.toLowerCase().split(" ");
            const optionString = `${option.materialDescription}`.toLowerCase();
            return inputArray.every((item) => optionString.includes(item));
          })
          .map((option, index, options) => (
            <ListItem
              key={index}
              disablePadding
              divider={index < options.length - 1}
              sx={{
                alignItems: "flex-start",
              }}
            >
              <ListItemButton
                sx={{
                  alignItems: "flex-start",
                  pl: "5px",
                }}
                onClick={() => {
                  handleClose();
                  setSelectedOption(options[index]);
                  setQueryParams({
                    siteId: options[index].siteId,
                  });
                }}
              >
                <Box>
                  <Typography>{t(`${option.siteName}`)}</Typography>
                  {option.street && (
                    <Typography display="block" variant="caption">
                      {option.street}
                    </Typography>
                  )}
                  {option.siteNumber && (
                    <Typography display="block" variant="caption">
                      {`ID:${option.siteNumber}`}
                    </Typography>
                  )}
                </Box>
              </ListItemButton>
            </ListItem>
          ))}
      </List>
    </Paper>
  );
};

export default SitesPopover;
